// src/hooks/useFinanceiro.js
import { useEffect, useState, useCallback } from "react";
import { api } from "../api/api";

export default function useFinanceiro(autoFetch = true) {
  const [parcelas, setParcelas] = useState([]);
  const [resumo, setResumo] = useState(null);
  const [loading, setLoading] = useState(false);

  // 📅 parcelas (movimentação real)
  const buscarParcelas = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get("/parcelas");
      setParcelas(res.data);
    } catch (error) {
      console.error("Erro ao buscar parcelas", error);
    } finally {
      setLoading(false);
    }
  }, []);

  // 📊 resumo financeiro (dashboard)
  const buscarResumo = useCallback(async () => {
    try {
      const res = await api.get("/financeiro/resumo");
      setResumo(res.data);
    } catch (error) {
      console.error("Erro ao buscar resumo", error);
    }
  }, []);

  // 💳 pagar parcela
  const pagarParcela = useCallback(async (parcela) => {
    const id = typeof parcela === "object" ? parcela._id : parcela;
    const res = await api.patch(`/parcelas/${id}/pagar`);

    setParcelas((prev) =>
      prev.map((p) => (p._id === id ? res.data : p))
    );

    buscarResumo();
    buscarParcelas();
  }, [buscarParcelas, buscarResumo]);

  // 📜 Buscar lançamentos de um cliente específico (memorizado com useCallback)
  const buscarHistoricoCliente = useCallback(async (clienteId) => {
    if (!clienteId) return [];
    try {
      const res = await api.get(`/parcelas?clienteId=${clienteId}`);
      return res.data;
    } catch (error) {
      console.error("Erro ao buscar histórico do cliente", error);
      throw error;
    }
  }, []);

  // 🔄 Renegociar / Editar Lançamento
  const renegociarLancamento = useCallback(async (financeiroId, dados) => {
    const res = await api.put(`/financeiro/${financeiroId}`, dados);
    await buscarParcelas();
    await buscarResumo();
    return res.data;
  }, [buscarParcelas, buscarResumo]);

  const criarValorCausa = useCallback(async ({
    clienteId,
    processoId,
    valorTotal,
  }) => {
    await api.post("/financeiro", {
      clienteId,
      processoId,
      tipo: "valorCausa",
      valorTotal,
      descricao: "Valor da causa",
    });
  }, []);

  // Executa as buscas globais APENAS se autoFetch for true
  useEffect(() => {
    if (autoFetch) {
      buscarParcelas();
      buscarResumo();
    }
  }, [autoFetch, buscarParcelas, buscarResumo]);

  return {
    parcelas,
    resumo,
    loading,
    buscarParcelas,
    buscarResumo,
    pagarParcela,
    buscarHistoricoCliente,
    renegociarLancamento,
    criarValorCausa,
  };
}